import { render, staticRenderFns } from "./FormProductCategoryComponent.vue?vue&type=template&id=2a23dd2e&scoped=true"
import script from "./FormProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./FormProductCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductCategoryComponent.vue?vue&type=style&index=0&id=2a23dd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23dd2e",
  null
  
)

export default component.exports